<template>
  <CustomCreateDialog
    dialogTitle="ایجاد کلاس گروهی جدید"
    dialogId="create-group-class-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateGroupClassRequest"
  >
    <BCol cols="12">
      <TextInput
        inputId="groupClassName"
        inputLabel="عنوان کلاس گروهی"
        inputPlaceholder="آیلتس مقدماتی"
        v-model="newGroupClassPayload.name"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        type="text"
        inputmode="numeric"
        customRules="required|min:1"
        inputId="groupClassDuration"
        inputLabel="مدت زمان کلاس (دقیقه)"
        inputPlaceholder="50"
        v-model="newGroupClassPayload.duration"
      >
        <template #append> دقیقه </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        type="text"
        inputmode="numeric"
        customRules="required|min:1"
        inputId="groupClassMinUserCapacity"
        inputLabel="حداقل تعداد شرکت کننده ها"
        inputPlaceholder="7"
        v-model="newGroupClassPayload.minUserCapacity"
      >
        <template #append> نفر </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        type="text"
        inputmode="numeric"
        customRules="required|min:1"
        inputId="groupClassMaxUserCapacity"
        inputLabel="حداکثر تعداد شرکت کننده ها"
        inputPlaceholder="15"
        v-model="newGroupClassPayload.maxUserCapacity"
      >
        <template #append> نفر </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12" class="my-1">
      <BFormCheckbox
        v-model="isFreeGroupClass"
        name="free-group-class-checkbox"
        switch
      >
        <small style="margin-left: 3px">آیا کلاس گروهی رایگان است؟</small>

        <b>({{ isFreeGroupClass ? "بله" : "خیر" }})</b>
      </BFormCheckbox>
    </BCol>
    <BCol cols="12" v-if="!isFreeGroupClass">
      <CustomAppendText
        :isText="true"
        type="text"
        inputmode="numeric"
        customRules="required|min:1"
        inputId="groupClassUserBasePrice"
        inputLabel="قیمت پایه زبان آموز"
        inputPlaceholder="50000"
        v-model="formattedUserBasePriceInput"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12" v-if="!isFreeGroupClass">
      <CustomAppendText
        :isText="true"
        type="text"
        inputmode="numeric"
        customRules="required|min:1"
        inputId="groupClassMasterBasePrice"
        inputLabel="قیمت پایه استاد"
        inputPlaceholder="35000"
        v-model="formattedMasterBasePriceInput"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      newGroupClassPayload: {
        name: null,
        duration: null,
        minUserCapacity: null,
        maxUserCapacity: null,
        userBasePrice: null,
        masterBasePrice: null,
      },
      isOkButtonDisabled: false,
      isFreeGroupClass: false,
    };
  },
  methods: {
    async sendCreateGroupClassRequest() {
      try {
        this.isOkButtonDisabled = true;
        if (this.isFreeGroupClass) {
          this.newGroupClassPayload.userBasePrice = 0;
          this.newGroupClassPayload.masterBasePrice = 0;
        } else {
          this.newGroupClassPayload.userBasePrice =
            this.newGroupClassPayload.userBasePrice.replaceAll(",", "");

          this.newGroupClassPayload.masterBasePrice =
            this.newGroupClassPayload.masterBasePrice.replaceAll(",", "");
        }

        let _this = this;
        let createGroupClass = new CreateGroupClass(_this);
        createGroupClass.setRequestParamDataObj(_this.newGroupClassPayload);
        await createGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس گروهی با موفقیت ایجاد شد.",
              },
            });
            _this.newGroupClassPayload = {
              name: null,
              duration: null,
              minUserCapacity: null,
              maxUserCapacity: null,
              userBasePrice: null,
              masterBasePrice: null,
            };
            this.$bvModal.hide("create-group-class-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
  },
  computed: {
    formattedUserBasePriceInput: {
      get() {
        return this.newGroupClassPayload.userBasePrice;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.newGroupClassPayload.userBasePrice = this.convertNumbers2English(
            newValue
          )
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.newGroupClassPayload.userBasePrice =
            this.newGroupClassPayload.userBasePrice.replace(
              /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
              ""
            );
        } else if (!newValue || newValue === "") {
          this.newGroupClassPayload.userBasePrice = "";
        }
      },
    },
    formattedMasterBasePriceInput: {
      get() {
        return this.newGroupClassPayload.masterBasePrice;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.newGroupClassPayload.masterBasePrice =
            this.convertNumbers2English(newValue)
              .toString()
              .replaceAll(",", "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.newGroupClassPayload.masterBasePrice =
            this.newGroupClassPayload.masterBasePrice.replace(
              /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
              ""
            );
        } else if (!newValue || newValue === "") {
          this.newGroupClassPayload.masterBasePrice = "";
        }
      },
    },
  },
  components: {
    CustomCreateDialog,
    CustomAppendText,
    TextInput,
    BCol,
    BFormCheckbox,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol, BFormCheckbox } from "bootstrap-vue";
import { CreateGroupClass } from "@/libs/Api/GroupClass";
</script>
